import { useMemo } from 'react';
import { useLanguage } from '../../context/LanguageContext';
import { useUpdateCurrentUser } from '../../hooks/useUpdateCurrentUser';
import { UI_LANGUAGE_TAGS } from '../../constants/constants';
import { displayLanguageName } from '../../constants/utilityFunctions';
import { Radio, RadioGroup, Text } from '../Ant';

const LanguageList = () => {
  const { language, changeLanguage, getAppLanguageCode } = useLanguage();
  const { mutate: updateUser } = useUpdateCurrentUser();
  const appLanguage = getAppLanguageCode();

  const languages = useMemo(
    () =>
      Object.keys(UI_LANGUAGE_TAGS).map((value) => ({
        value,
        label: displayLanguageName(value, appLanguage),
      })),
    [appLanguage],
  );

  const handleChange = (value: string) => {
    const previousLanguage = language;
    changeLanguage(value);
    updateUser(
      { uiLanguage: UI_LANGUAGE_TAGS[value] },
      { onError: () => changeLanguage(previousLanguage) },
    );
  };

  return (
    <RadioGroup
      value={language}
      onChange={(e) => handleChange(e.target.value)}
      className="d-flex fd-column grouped-list"
      data-testid="language-list"
    >
      {languages.map((lang) => (
        <Radio key={lang.value} value={lang.value} data-testid={`language-option-${lang.value}`}>
          <Text $fontsize="13px" $color="title" $weight={500} $lineheight="20px">
            {lang.label}
          </Text>
        </Radio>
      ))}
    </RadioGroup>
  );
};

export default LanguageList;
